<script setup lang="ts">
import { twMerge } from "tailwind-merge";

import { useUser } from "@/composables/api/useUser";

import HourglassIcon from "@/components/icons/HourglassIcon.vue";

const { data: user } = useUser();
</script>

<template>
  <ul role="list" class="flex flex-col">
    <li class="flex w-full items-center gap-3 border-b border-[#D8E1E7] py-2 lg:gap-4 lg:py-3">
      <span class="text-secondary w-full text-base font-medium lg:text-lg">
        {{ $t("receipt.emptyList") }}
      </span>

      <HourglassIcon
        :class="
          twMerge('text-galbani size-10', user?.current_mechanic === 'lactel' && 'text-lactel-blue')
        "
      />
    </li>
  </ul>
</template>
